import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CardHeader,
  Media,
  Input,
  Badge,
} from "reactstrap";
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
} from "@themesberg/react-bootstrap";

import SpinDiv from "../components/SpinDiv";
import AddPromotion from "./AddPromotion";
import moment from "moment";
import { throttle,debounce } from "./debounce";
import 'antd/dist/antd.css';
import { Pagination } from 'antd';
import EditPromotion from "./EditPromotion";
import { getPromotions } from "../../services/promotionService";
import DeletePromotion from "./DeletePromotion";

export class PromotionIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      employees: [],
      designations:[],
      promotions:[],
      total: 0,
      user:JSON.parse(localStorage.getItem('user')),

    

    };
    this.searchDebounced = debounce(this.searchPromotions, 500);
    this.searchThrottled = throttle(this.searchPromotions, 500);
  }

  componentDidMount() {
    this.searchPromotions();
  }

  

  searchPromotions = () => {
    const { page, rows, search, promotions } = this.state;
    this.setState({ loading: true });
    getPromotions({ page, rows, search, promotions }).then(

      (res) => {
        this.setState({
          promotions: res.promotions.data,
          employees: res.employees,
          designations:res.designations,
          page: res.promotions.current_page,
          total: res.promotions.total,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

 

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onPage = async (page,rows) => {
    await this.setState({page,rows});
    await this.getPromotions();
  }
  
  handleSearch = event => {
    this.setState({ search: event.target.value }, () => {
      if(this.state.search < 5){
        this.searchThrottled(this.state.search);
      }else{
        this.searchDebounced(this.state.search);
      }
    
    });
  };
  
 

  toggleEditPromotion = (editPromotion) => {
    this.setState({ editPromotion});
    this.searchPromotions();
   
  };
  toggleClosePromotion=(editPromotion)=>{
    this.setState({ editPromotion: !this.state.editPromotion });
  }

 

  toggleAddPromotion = () => {
    this.setState({ addPromotion: !this.state.addPromotion });
    this.searchPromotions();
  }

  
  toggleDeletePromotion=(deletePromotion)=>{
    this.setState({ deletePromotion });
  }

  toggle = () => {
    this.setState({ deletePromotion: !this.state.deletePromotion });
  }

  
  



  




  

  render() {
    const { employees,promotions,user, designations, total, page, rows, search, loading,addPromotion, editPromotion, deletePromotion } = this.state;
    
    return (
      <>
       
        
        {addPromotion && (
          <AddPromotion
            saved={this.searchPromotions}
            employees={employees}
            designations={designations}
            toggle={this.toggleAddPromotion}
            
          />
        )}

        {editPromotion && (
          <EditPromotion
            saved={this.searchPromotions}
            employees={employees}
            promotion={editPromotion}
            designations={designations}
            toggle={this.toggleClosePromotion}
          />
        )}

        
        {deletePromotion && (
          <DeletePromotion
            saved={this.searchPromotions}
            promotion={deletePromotion}
            toggle={this.toggle}
          />
        )}

      
       
        {loading && <SpinDiv text={"Loading..."} />}

        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#users">Promotions</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              {user.admin == 1 && <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                  <Button variant="outline-primary" size="sm" onClick={() => this.toggleAddPromotion()}>
                    Create Promotion
                  </Button>
                  {/* <Button variant="outline-primary" size="sm">
                    Export
                  </Button> */}
                </ButtonGroup>
              </div>}
              
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="8">
          <h5 className="mb-0">Promotions
          <span style={{color: '#aaa', fontSize: 14, fontWeight: 'normal'}}> ({total})</span></h5>
          </Col>
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                autoFocus
                id="show"
                value={search}
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                onChange={this.handleSearch}
                
              />
            </div>
          </Col>
        </Row>

        <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0">Employees</th>
                  <th className="border-0">Title</th>
                  <th className="border-0">Date</th>
                  <th className="border-0">actions</th>
                </tr>
              </thead>
              <tbody>
                
                {promotions.map((promotion, key) => {
               
                  return (
                    <tr >
                     <th scope="row">
                      <td>
                        <Media className="align-items-center">
                          <a
                            className="avatar rounded-circle mr-3"
                            href="#p"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              style={{
                                maxHeight: 50,
                                maxWidth: 50,
                                borderRadius: '100%',
                              }}
                              alt="..."
                              src={
                                promotion.image ||
                                require("../../assets/img/brand/user.jpg")
                              }
                            />
                           
                          </a>
                          </Media>
                        </td>
                        <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{promotion.name}</span>
                      </td>
                        
                      </th>
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{promotion.title}</span>
                      </td>
                        
                    
                      <td>{moment(promotion.dated).format('MMM D, YYYY')}</td>
      
                    
                      <td>
                        
                        <ButtonGroup>
                          <Button variant="outline-primary" 
                          style={{fontWeight:"bold",textTransform:"capitalize"}} 
                          onClick={() => this.toggleEditPromotion(promotion)} size="sm">
                            view
                          </Button>
                          <Button
                            variant="outline-danger"
                            onClick={() => {
                              this.toggleDeletePromotion(promotion)
                            }}            
                            size="sm"
                          >
                            Delete
                          </Button>  
                        
                          
                        </ButtonGroup>
                      </td>

                      
                      
                    </tr>
                  );
                })}
              </tbody>
             
            </Table>
            <Row>
              <Col md={12} style={{fontWeight:"bold",paddingTop:3}}>
              {promotions.length<1&&
                <div style={{color: '#ccc', alignSelf: 'center', padding: 10, fontSize: 13}}>
                  <i className="fa fa-ban" style={{marginRight: 5}}/>
                  No Promotions yet
                </div>}
              {promotions.length > 0 && <Pagination
                  total={total}
                  showTotal={total => `Total ${total} promotions for all Employees`}
                  onChange={this.onPage}
                  pageSize={rows}
                  current={page}
                />}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default PromotionIndex;
